export const pillarOption = {
  color: ['#ffc359', '#42d596'],
  xAxis: {
    axisLabel: {
      color: '#fff9',
      // interval: 0,
    },
    splitLine: {
      lineStyle: {
        color: '#d9d9d9',
      },
    },
    axisLine: {
      lineStyle: {
        color: '#ffffff33',
      },
    },
    type: 'category',
    data: ['汽机', '锅炉', '电一', '电二'],
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    axisLabel: {
      color: '#fff9',
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      lineStyle: {
        color: 'rgba(255,255,255,0.05)',
      },
    },
    minInterval: 1,
    type: 'value',
    name: '',
    nameTextStyle: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 12,
      padding: [0, 30, 0, 0],
    },
    nameLocation: 'end',
    splitNumber: 4,
  },
  tooltip: {
    trigger: 'axis',
    confine: true,
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: '#04454a80',
    borderColor: '#35d0dd',
    borderWidth: 1,
  },
  grid: {
    left: 40,
    bottom: 30,
    right: 0,
    top: 30,
  },
  legend: {
    top: 0,
    left: 'right',
    data: ['失败数', '成功数'],
    icon: 'rect',
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 30,
    textStyle: {
      color: '#fff',
      fontSize: 12,
    },
  },
  dataZoom: {
    show: false,
    start: 0,
    end: 100,
    height: 12,
    bottom: '10',
    textStyle: {
      color: 'rgba(255,255,255,0.6)',
    },
    borderColor: 'transparent',
    backgroundColor: '#062830',
    fillerColor: '#185663',
  },
  series: [
    {
      name: '失败数',
      data: [68, 76, 60, 80],
      type: 'bar',
      barWidth: 8,
    },
    {
      name: '成功数',
      data: [20, 5, 30, 12],
      type: 'bar',
      barWidth: 8,
    },
  ],
}

export const lineOption = {
  color: ['#44f1ff', '#ffc058', '#3cd495'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: '#04454a80',
    borderColor: '#35d0dd',
    borderWidth: 1,
    textStyle: {
      fontSize: 12,
    },
  },
  legend: {
    textStyle: {
      color: '#ffffffb3',
    },
    // right: 0,
    // top: -2,
    // icon: 'circle',
    itemWidth: 15,
    itemHeight: 10,
    show: false,
    padding: [30, 0, 0, 0],
  },
  grid: {
    top: 10,
    bottom: 20,
    left: 50,
    right: 20,
  },
  xAxis: {
    type: 'category',
    data: ['0%-30%', '30%-60%', '60%-90%', '90%-100%'],
    splitArea: {
      show: false,
      areaStyle: {
        color: ['rgba(255,255,255,0.05)', 'transparent'],
      },
    },
    splitLine: {
      show: false,
    },
    axisLabel: {
      color: '#fff9',
      fontSize: 12,
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: '#ffffff4d',
      },
    },
  },
  yAxis: {
    type: 'value',
    splitLine: {
      lineStyle: {
        color: ['rgba(255,255,255,0.05)'],
        type: 'dashed',
      },
    },
    splitNumber: 3,
    name: '（百）',
    nameLocation: 'end',
    nameGap: 10,
    nameTextStyle: {
      color: '#fff9',
      // padding: [-10, 0, 0, -30],
      fontSize: 12,
    },
    minInterval: 1,
    splitArea: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      color: '#fff9',
      fontSize: 12,
    },
    axisLine: {
      show: false,
      lineStyle: {
        color: '#ffffff4d',
      },
    },
  },
  series: [
    {
      type: 'line',
      name: '服务器数',
      data: [3, 5, 9, 4],
      showSymbol: true, // 隐藏拐点
    },
  ],
}

export default {}
